export const checkoutPageConstant = {
  PAGE_TITLE: 'My Checkout Page | Lakeshore® Learning Materials',
  SEE_PRIVACY_POLICY: 'See Privacy Policy',
  SEE_PRIVACY_POLICY_URL: '/about/privacy-policy',
  INTERNATIONAL_SHIP_MSG:
    "Shipping costs vary for orders sent outside the United States. We'll email you a shipping quote in 1-2 business days.",
  orderType: {
    web: 'webOnly',
    store: 'instorePickUpOnly',
    webAndStore: 'webAndInstorePickup',
  },
  registryAddressMessage:
    'Registry Address - Ships to the address provided by registrant',
  clearTheListAddressMessage:
    'Address - Ships to the address provided by list owner',
};

export const ORDER_TYPES = {
  WEB_ONLY: 'webOnly',
  BOPIS_ONLY: 'instorePickUpOnly',
  MiXED_ORDER: 'webAndInstorePickup',
};

export const CHECKOUT_VALIDATION_MESSAGES = {
  ADDRESS_REQUIRED: 'Please enter an address.',
  ADDRESS_INVALID: 'Please enter a valid address.',
  CC_CVV_INVALID: 'Please enter a valid CVV number.',
  CC_CVV_MISSING: 'Please enter CVV number.',
  CC_EXPIRY_MISSING: 'Please enter a valid month and year.',
  CC_EXPIRY_INVALID: 'Please enter a valid expiration date.',
  CC_YEAR_INVALID: 'Year cannot be in the past.',
  CC_MONTH_INVALID: 'Month must be between 01 and 12.',
  CC_NUM_INVALID: 'Please enter a valid card number.',
  CC_NUM_MISSING: 'Please enter a card number.',
  CC_EXPIRED: 'This credit card is expired.',
  CITY_REQUIRED: 'Please enter a city.',
  CITY_INVALID: 'Please ender a valid city.',
  COUNTRY_REQUIRED: 'Please select a country.',
  EMAIL_INVALID: 'Please enter a valid email address.',
  EMAIL_REQUIRED: 'Please enter an email address.',
  FIRST_NAME_REQUIRED: 'Please enter a first name.',
  FIRST_NAME_INVALID: 'Please enter a valid name.',
  LAST_NAME_REQUIRED: 'Please enter a last name.',
  STATE_REQUIRED: 'Please select a state.',
  POSTAL_CODE_REQUIRED: 'Please enter Zip/Postal Code.',
  PHONE_NO_REQUIRED: 'Please enter a valid phone #.',
  PHONE_NO_IS_REQUIRED: 'Please enter a phone number.',
  PHONE_NO_MINLENGTH: 'Phone number must be 10 digits long.',
  PASSWORD_REQUIRED: 'Please enter password.',
  PASSWORD_INVALID: 'Please enter a valid password.',
  GIFT_CARD_NUMBER_REQUIRED: 'Please enter gift card #.',
  GIFT_CARD_AUTH_REQUIRED: 'Please enter the auth #.',
  GIFT_CARD_AUTH_INVALID: 'Please enter a valid auth #.',
  GIFT_CARD_NUMBER_INVALID: 'Please enter a valid gift card #.',
  GIFT_FROM_REQUIRED: 'Please enter a name.',
  GIFT_FROM_INVALID: 'Please enter in a valid format.',
  INSTITUTION_NAME_INVALID: 'Please enter a valid school/institution.',
  LAST_NAME_INVALID: 'Please enter a valid name.',
  PHONE_NO_INVALID: 'Please enter a valid phone #.',
  POA_SCHOOL_INSTITUTION_REQUIRED: 'Please enter a valid school/institution.',
  POA_SCHOOL_INSTITUTION_INVALID: 'Please enter a valid school/institution.',
  POA_NUMBER_INVALID: 'Please enter a valid PO #.',
  POSTAL_CODE_INVALID: 'Please enter a valid zip code.',
  PROMO_CODE_REQUIRED: 'Please enter a valid code.',
};

export const CHECKOUT_WARNING_MESSAGE = {
  CHECKOUT_NO_PAYMENT_REQUIRED: 'No additional payment needed.',
  CHECKOUT_SIGN_IN_CHANGED_TOTAL:
    'When you signed in, additional items appeared in your cart. Please review your order.',
  CHECKOUT_ZERO_BALANCE_GC: 'That gift card has a zero balance.',
  DISABLED_GIFT_CARD_LAKESHORE_BUCKS:
    'Sorry! Gift cards and Lakeshore Bucks cannot be used for gift card purchases. Lakeshore Bucks cannot be used for orders paid on account.',
  GIFT_CARD_NO_PAYMENT_REQUIRED:
    'You have covered your balance with gift card(s). No additional payment is required.',
  BOPIS_STORE_DISABLED:
    "We're sorry! Store pickup is temporarily unavailable at your selected store. We have adjusted your cart to ship any applicable items instead.",
  BOPIS_STORES_CLOSE_HOLIDAY:
    'Due to the holiday, stores will be closed {0}, which may affect store pickup. Call your store for details.',
  BOPIS_STORES_CLOSE_UNEXPECTED:
    "We're sorry, but store pickup at this location may be delayed. Don't worry, though—you can still place your order! We'll notify you as soon as it's ready for pickup.",
  BOPIS_STORES_CLOSE_UNEXPECTED_2:
    "We're sorry, but store pickup at this location may be delayed. We'll notify you as soon as your order is ready for pickup!",
  SHIP_ADDRESS_PO_BOX:
    'To track your shipment, we recommend using a street address instead of a P.O. Box.',
};

export const MiniCartItem = {
  digital: 'FIRST_DIGITAL_ITEM',
  store: 'FIRST_ROPIS_ITEM',
  ship: 'FIRST_NON_ROPIS_ITEM',
  none: 'NONE',
};

// Mapping of points to dollars for lakeshore bucks
export const pointToDollarMap = [
  { points: 5000, dollars: 50 },
  { points: 2000, dollars: 20 },
  { points: 1500, dollars: 15 },
  { points: 1000, dollars: 10 },
  { points: 500, dollars: 5 },
];

export const PAYMENT = {
  NEW_CREDIT_CARD: 'newCreditCard',
  EXISTING_CREDIT_CARD: 'existingCreditCard',
  CREDIT_CARD: 'creditCard',
  POA_CARD: 'poaCard',
  TAX_POA_CARD: 'taxPoaCard',
  ON_ACCOUNT_CARD: 'onAccountCard',
  ADD_NEW_CC: 'creditCard',
  NONE: 'none',
  ON_ACCOUNT: 'onAccount',
  PAYPAL_OPTION: 'paypalOption',
  GOOGLE_PAY: 'googlePay',
  PAYPAL_AMOUNT_VALIDATION: 8000,
  PAYPAL_VALIDATION_MSG:
    'Since this order requires a shipping quote, PayPal is not an available payment option.',
  CREDIT_CARD_TYPE: {
    VISA: 'Visa',
    MASTERCARD: 'Mastercard',
    AMERICAN_EXPRESS: 'AmericanExpress',
    DISCOVER: 'Discover',
  },
  CREDIT_CARD_VALIDATION: {
    Visa: /^4[0-9]{0,}$/,
    Mastercard: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$/,
    AmericanExpress: /^3[47][0-9]{0,}$/,
    Discover: /^6(?:011|(4|5)[0-9]{0,})[0-9]{0,}$/,
  },
  CREDIT_CARD_IMG: {
    Visa: '/react/assets/icons/visa.svg',
    Mastercard: '/react/assets/icons/mastercard.svg',
    AmericanExpress: '/react/assets/icons/amex.svg',
    Discover: '/react/assets/icons/discover.svg',
  },
};

export const FIELD_VALIDATION_RULES = {
  ADDRESS_ONE: /^[a-zA-Z0-9 `~!@#$%^*()\-_=+|;:,.?'/]{1,}$/,
  CA_ZIP_CODES: /(^[A-Za-z0-9]{6})$|(^[A-Za-z0-9]{3}[\s]{1}[A-Za-z0-9]{3})$/,
  CITY: /^[a-zA-Z\s\-.'’]+$/,
  CREDIT_CARD_CVV: /^\d{3,4}$/,
  CREDIT_CARD_EXPIRY: /^(0[1-9]|1[0-2])\/\d{2}$/,
  CREDIT_CARD_MIN_LENGTH: 15,
  CREDIT_CARD_NUMBER: {
    Visa: /^4[0-9]{15,19}$/,
    Mastercard:
      /^(5[1-5][0-9]{14}|2(2[2-9][0-9]{12}|[3-6][0-9]{13}|7[01][0-9]{12}|720[0-9]{12}))$/,
    AmericanExpress: /^3[47][0-9]{13}$/,
    Discover: /^6(?:011|(4|5)[0-9]{0,})[0-9]{12}$/,
  },
  EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  FIRST_NAME: /^[a-zA-Z0-9\s\-.'’]+$/,
  GIFT_CARD_AUTH: /^\d{1,4}$/,
  GIFT_CARD_NUM: /^\d{16}$/,
  INSTITUTION_NAME: /^[a-zA-Z0-9 `~!@#$%^*()\-_=+|;:,.?'/]{1,}$/,
  INTERNATIONAL_PHONE: /^\d{1,15}$/,
  INTERNATIONAL_ZIP_CODES: /^[a-zA-Z0-9\-\s]{1,10}$/,
  LAST_NAME: /^[a-zA-Z0-9\s\-.'’]+$/,
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d`~!@#$%^*()\-_=+|;:,.?]{10,35}$/,
  POA_NUMBER: /^[a-zA-Z0-9 :-]{1,50}$/,
  POA_SCHOOL_INSTITUTION: /^[a-zA-Z0-9 `~!@#$&%^*()\-_=+|;:,.?'/]{1,50}$/,
  US_CA_PHONE: /^\d{10}$/,
  US_ZIP_CODES: /(^\d{5})$|(^\d{5})[-\s]?([\dA-Za-z]{4})$/,
};

export const FIELD_ACCEPTED_CHARACTERS = {
  EMAIL: /[^a-zA-Z0-9.!#$%&'*+/=?^_`~@-]/g,
  FIRST_NAME: /[^a-zA-Z0-9\s\-.'’]/g,
  LAST_NAME: /[^a-zA-Z0-9\s\-.'’]/g,
  INSTITUTION_NAME: /[^a-zA-Z0-9 `~!@#$%^*()\-_=+|;:,.?'/]/g,
  ATTENTION_NAME: /[^a-zA-Z0-9 `~!@#$%^*()\-_=+|;:,.?'/]/g,
  ADDRESS_ONE: /[^a-zA-Z0-9 `~!@#$%^*()\-_=+|;:,.?'/]/g,
  ADDRESS_TWO: /[^a-zA-Z0-9 `~!@#$%^*()\-_=+|;:,.?'/]/g,
  CITY: /[^a-zA-Z\s\-.'’]/g,
  STATE: /[^a-zA-Z0-9\s\-.'’]/g,
  ZIP_CODE: /[^a-zA-Z0-9\s-]/g,
  PROMO_CODE: /[^a-zA-Z0-9]/g,
  REGISTRY_GIFT_NAME: /[^a-zA-Z0-9\s\-.'’]/g,
  POA_SCHOOL_INSTITUTION: /[^a-zA-Z0-9 `~!@#$%&^*()\-_=+|;:,.?'/]/g,
};

export const SessionExpiryMessages = {
  sessionAboutToExpire:
    'Your session is about to expire. Please click "continue" to refresh your session.',
  sessionExpiredSignedIn: 'Due to inactivity, your session has expired.',
  sessionExpiredGuest:
    'Due to inactivity, your session has expired. For customer security, any information entered in Checkout has been removed.',
};
